import McpConnectionsList from "../Components/ComoAgents/McpConnectionsList";

const McpConnectionsListPage = () => {
  return <McpConnectionsList />;
};

export default McpConnectionsListPage;
